import type { ElementType } from 'react';

import { t } from '@/utils/lang';

import { StatusTicketEnum } from '@/types/enums/status-ticket.enum';
import Chip from '@mui/material/Chip';

export interface StatusChipProps {
    status: StatusTicketEnum;
    size?: 'small' | 'medium';
    component?: ElementType;
    showChip?: boolean;
}

const ChipTicketStatus = ({
    status,
    size = 'medium',
    component: Component = Chip,
    showChip = true,
}: StatusChipProps) => {
    let label: string;
    let color: 'info' | 'warning' | 'success' | 'error' | 'default';

    switch (status?.toLowerCase()) {
        case StatusTicketEnum.CREATED.toLowerCase():
            label = 'Mới';
            color = 'info';
            break;
        case StatusTicketEnum.CLOSED.toLowerCase():
            label = 'Hoàn thành';
            color = 'success';
            break;
        case StatusTicketEnum.CANCEL.toLowerCase():
            label = 'Đã hủy';
            color = 'error';
            break;
        default:
            label = t('Không xác định');
            color = 'default';
            break;
    }

    if (showChip) {
        return (
            <Component
                variant='tonal'
                label={t(label, 'TicketStatus')}
                color={color}
                size={size}
            />
        );
    }

    return {
        label: t(label, 'TicketStatus'),
        color,
    };
};

export default ChipTicketStatus;
